export enum MessageRecipientType {
    Customer = 1,
    Agent = 2,
}

export default MessageRecipientType;
